import { CircularProgress } from '../CircularProgress';

import { StyledButton } from './Button.styles';
import { ButtonProps } from './types';

/**
 * Button component.
 */
export const Button = ({
  label,
  mode = 'standard',
  disabled,
  loading,
  startIcon,
  endIcon,
  className,
  fullWidth,
  colorVariant = 'primary',
  sizeVariant = 'l',
  spaceBetween,
  onClick,
}: ButtonProps) => (
  <StyledButton
    disableRipple
    className={className}
    colorVariant={colorVariant}
    disabled={disabled || loading}
    endIcon={endIcon}
    fullWidth={fullWidth}
    loading={loading}
    mode={mode}
    sizeVariant={sizeVariant}
    spaceBetween={spaceBetween}
    startIcon={startIcon}
    onClick={onClick}
  >
    <span className="button-label">{label}</span>
    {loading && (
      <span className="button-loading">
        <CircularProgress />
      </span>
    )}
  </StyledButton>
);
